import React, { ChangeEvent } from "react";
import { CFormInput } from "@coreui/react";
import { useAuth } from "../../context/AuthContext";
import {
  generateDocumentAuthor,
  prepareAttachmentsPost,
  removeUnnecessaryFields,
} from "../../utils/helpers";

interface FileInputProps {
  updateFormValue: (field: string[], value: any) => void;
  size?: "sm" | "lg";
  field_name: string;
  placeholder?: string;
  nested_attachment?: boolean;
  [key: string]: any;
}

const FileInput: React.FC<FileInputProps> = ({
  updateFormValue,
  size,
  field_name,
  placeholder,
  form,
  is_array = false,
  ...props
}) => {
  const { user } = useAuth();
  const documentAuthor = generateDocumentAuthor(user);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const obj = {
      file: event.target.files?.length ? Array.from(event.target.files) : "",
      ...documentAuthor,
      // document_type: DOC_TYPE_OTHER ,
      document_type: field_name,
      caption: field_name,
    };
    // if (nested_attachment) {
    //   updateFormValue(
    //     ["attachment"],
    //     prepareAttachmentsPost([obj], "attachments"),
    //   );
    // }
    if (props?.parent_field) {
      const cleanedData = removeUnnecessaryFields(form?.[props?.parent_field]);
      if (!is_array) {
        updateFormValue(props?.parent_field, {
          ...cleanedData,
          ...prepareAttachmentsPost([obj], "attachments"),
        });
      } else {
        if (form?.[props?.parent_field]?.length > 0) {
          const index = props?.parent_index ?? 0;
          let updatedArray = [...form[props.parent_field]];
          updatedArray[index] = {
            ...updatedArray[index],
            ...prepareAttachmentsPost([obj], "attachments"),
          };
          updateFormValue(props.parent_field, updatedArray);
        } else {
          updateFormValue(props?.parent_field, [
            {
              ...prepareAttachmentsPost([obj], "attachments"),
            },
          ]);
        }
      }

      return;
    }
    updateFormValue([field_name], obj);
  };

  return (
    <CFormInput
      size={size}
      type="file"
      onChange={handleChange}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default FileInput;
